import VueFilter from 'vue-filter'
import moment from 'moment'

// import i18n from '@/i18n'

const Filters = {
  install: function (Vue) {
    Vue.use(VueFilter)

    Vue.filter('uppercase', function (value, mask) {
      if (value) {
        return value.toUpperCase()
      } else {
        return '---'
      }
    })

    Vue.filter('capitalize', function (value, mask) {
      if (!value) return ''
      value = value.toString()
      return value.charAt(0).toUpperCase() + value.slice(1)
    })

    Vue.filter('formatDateDay', function (value, mask) {
      if (value) {
        if (mask) {
          return moment(String(value), mask).format('DD/MM/YY')
        } else {
          return moment(value).format('DD')
        }
      } else {
        return '---'
      }
    })

    Vue.filter('formatDateMonth', function (value, mask) {
      const lang = window.$i18n && window.$i18n.locale
      if (value) {
        if (mask) {
          return moment(String(value), mask).locale(lang).format('DD/MM/YY')
        } else {
          return moment(value).locale(lang).format('MMM')
        }
      } else {
        return '---'
      }
    })

    Vue.filter('formatDateYear', function (value, mask) {
      if (value) {
        if (mask) {
          return moment(String(value), mask).format('DD/MM/YY')
        } else {
          return moment(value).format('YYYY')
        }
      } else {
        return '---'
      }
    })

    Vue.filter('formatDate', function (value, mask) {
      if (value) {
        if (mask) {
          return moment(String(value), mask).format('DD/MM/YY')
        } else {
          return moment(value).format('DD/MM/YY')
        }
      } else {
        return '---'
      }
    })

    Vue.filter('formatDateExtend', function (value, mask) {
      if (value) {
        if (mask) {
          return moment(String(value), mask).format('DD/MM/YYYY')
        } else {
          return moment(value).format('DD/MM/YYYY')
        }
      } else {
        return '---'
      }
    })

    Vue.filter('formatDateTime', function (value, mask) {
      if (value) {
        if (mask) {
          return moment(String(value), mask).format('DD/MM/YY HH:mm')
        } else {
          return moment(value).format('DD/MM/YY HH:mm')
        }
      } else {
        return '---'
      }
    })

    Vue.filter('formatDateFromNow', function (value) {
      if (value) {
        return moment(value).fromNow()
      } else {
        return '---'
      }
    })

    Vue.filter('age', function (value) {
      if (value) {
        return moment().diff(value, 'years', false)
      } else {
        return '---'
      }
    })

    Vue.filter('ageFriendly', function (value) {
      const $i18n = window.$i18n
      if (value) {
        const age = moment().diff(value, 'years', false)
        return age + ' ' + $i18n.tc('words.year', age)
        // console.log('i18n', i18n)
        // return `${age} ${i18n.tc('year', age)}`
      } else {
        return '---'
      }
    })

    Vue.filter('phone', function (value) {
      if (value) {
        return value.replace(/[^0-9]/g, '').replace(/(\d{2})(\d{2})(\d{5})(\d{4})/, '+$1 ($2) $3-$4')
      } else {
        return '---'
      }
    })

    Vue.filter('risk', function (value) {
      if (value) {
        return value.replace('in', 'em')
      } else {
        return '---'
      }
    })

    Vue.filter('cpf', function (value) {
      if (value && value.length === 11) {
        return `${value.substr(0, 3)}.${value.substr(3, 3)}.${value.substr(6, 3)}-${value.substr(9, 2)}`
      } else {
        return '---'
      }
    })

    Vue.filter('decimal', function (value) {
      const val = parseFloat(value)
      if (isNaN(val) || value === '') {
        return value
      } else {
        return val.toFixed(2)
      }
    })

    Vue.filter('precision', function (value, digits = 0) {
      if (isNaN(value) || value === '') {
        return value
      } else {
        const val = parseFloat(value)
        return val.toFixed(digits)
      }
    })

    Vue.filter('numberLocale', function (value, digits = 0) {
      if (isNaN(value) || value === '') {
        return value
      } else {
        const val = parseFloat(value)
        return val.toLocaleString(undefined, {maximumFractionDigits: digits})
      }
    })

    Vue.filter('weeksAndDays', function (value, dense) {
      const $i18n = window.$i18n
      if (value && !isNaN(Number(value))) {
        let ageDays = Math.round(value)
        let weeks = parseInt(ageDays / 7)
        let days = Math.round(ageDays % 7)
        if (dense) return `${weeks}s${days > 0 ? `${days}d` : ''}`
        else return `${weeks} ${$i18n.tc('words.week', weeks)} ${days > 0 ? `${$i18n.t('words.and')} ${days} ${$i18n.tc('words.day', days)}` : ''}`
      } else {
        return value
      }
    })

    Vue.filter('studiesAn', function (vals) {
      if (!vals || vals.length < 1) return ''

      return Object.entries(vals)
        .map(([id, item], index) => item.accessionNumber)
        .join(', ')
    })

    Vue.filter('studiesTitle', function (vals) {
      if (!vals || vals.length < 1) return ''

      return Object.entries(vals)
        .map(([id, item], index) => item.title)
        .join(', ')
    })

    Vue.filter('dynamicFilter', function (value, name, ...args) {
      return Vue.filter(name)(value, ...args)
    })

    Vue.filter('formatCompType', function (value, type) {
      if (!value) return '-'
      if (type === 'datepicker') {
        return Vue.filter('formatDate')(value)
      }
      if (type === 'chartline') {
        if (value.percentil) {
          return Vue.filter('decimal')(value.percentil)
        } else {
          return '-'
        }
      }
      return value
    })

    Vue.prototype.$filters = Vue.options.filters
  }
}

export default Filters



// WEBPACK FOOTER //
// ./src/utils/filters.js